'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'right-to-bracket';
var width = 512;
var height = 512;
var aliases = ["sign-in-alt"];
var unicode = 'f2f6';
var svgPathData = 'M201 95L345 239c9.4 9.4 9.4 24.6 0 33.9L201 417c-6.9 6.9-17.2 8.9-26.2 5.2S160 409.7 160 400l0-80-112 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l112 0 0-80c0-9.7 5.8-18.5 14.8-22.2S194.1 88.2 201 95zm-9 285.7L316.7 256 192 131.3 192 208c0 8.8-7.2 16-16 16L48 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l128 0c8.8 0 16 7.2 16 16l0 76.7zM336 448l80 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRightToBracket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;